export const PUBLICATION_LABELS = Object.freeze({
  DRAFT: 'Черновик', SCHEDULED: 'Запланировано', PUBLISHING: 'Публикуется',
  PUBLISHED: 'Опубликовано', FAILED: 'Ошибка публикации', HIDDEN: 'Скрыто', DELETED: 'Удалено',
});
export const PUBLICATION_FILTERS = [
  ['published', 'Опубликованные'], ['scheduled', 'Запланированные'], ['draft', 'Черновики'],
  ['publishing', 'Публикуются'], ['failed', 'С ошибками'], ['all', 'Все'],
].map(([value, title]) => ({ value, title }));

export function publicationLabel(item) {
  if (['HIDDEN', 'DELETED'].includes(item.status)) return PUBLICATION_LABELS[item.status];
  const state = item.publication?.state || item.state || item.status || (item.publishedAt ? 'PUBLISHED' : 'DRAFT');
  return PUBLICATION_LABELS[state] || 'Неизвестный статус';
}

export function moscowInput(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return '';
  const parts = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Moscow', year: 'numeric',
    month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value));
  const get = type => parts.find(p => p.type === type)?.value;
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

export function moscowSchedule(value, now = Date.now()) {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value || '')) throw new Error('Выберите дату и время публикации (МСК)');
  const date = new Date(`${value}:00+03:00`);
  if (!Number.isFinite(date.getTime()) || moscowInput(date.toISOString()) !== value || date.getTime() <= now)
    throw new Error('Выберите будущую дату и время публикации (МСК)');
  return date.toISOString();
}

export function displayMoscow(value) {
  const input = moscowInput(value);
  if (!input) return '—';
  const [date, time] = input.split('T');
  return `${date.split('-').reverse().join('.')} ${time} МСК`;
}

export function scheduledDisplayDate(value) { return `${moscowInput(value).slice(0, 10)}T12:00:00.000Z`; }

export function publicationDate(value) {
  if (value instanceof Date) {
    const day = `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
    return `${day}T12:00:00.000Z`;
  }
  return new Date(value).toISOString();
}

export async function publicationRequest(api, kind, id, body) {
  if (!['materials', 'academies'].includes(kind) || !Number.isInteger(Number(id)) || Number(id) < 1)
    throw new Error('Некорректный материал');
  const { data } = await api.request({ path: `/dashboard/publications/${kind}/${id}`,
    method: body ? 'POST' : 'GET', secure: true, format: 'json', type: 'application/json', body });
  return data;
}

export function publicationError(error) {
  const message = error.response?.data?.message;
  return (Array.isArray(message) ? message.join('; ') : message) || error.message || 'Не удалось выполнить действие';
}
